<script setup lang="ts">
import { useColorMode } from '@vueuse/core';

const mode = useColorMode();
const logo = computed(() => {
  return mode.value === 'dark' ? '/logo.svg' : '/logo-black.svg';
});
</script>

<template>
  <div class="flex justify-center mb-8">
    <img :src="logo" alt="RETAINTIVE.AI" class="h-[85px] w-auto" />
  </div>
</template>

<style scoped></style>
